import React from 'react'

const Tabs = ({ tabs, currentTab, tab_name, tabsToDisplay }) => {
    return (
        <div class="steps">
            {tabs && Array.isArray(tabs) && tabs?.map((item, index) =>
                <div style={{
                    display: item.isHidden ? 'none' : 'flex', // Hide tab if isHidden is true
                }} className={`step ${currentTab == index ? "active" : ""} ${index < currentTab ? "completed" : ""} `} data-step={index}>{item?.tab_name}</div>
            )
            }
        </div>

    )
}

export default Tabs